var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$route.meta.breadcrumbs)?_c('div',[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"page-path"},[_vm._v(_vm._s(_vm.$t('menu.' + this.$route.meta.serviceSlug))+" · ")]),_c('span',{staticClass:"page-name"},[_vm._v(_vm._s(_vm.$t('menu.' + this.$route.meta.pageName)))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }